export var ONLINE = "ONLINE";
export var OFFLINE = "OFFLINE";
